import { Injectable } from "@angular/core";
import { createEffect } from "@ngrx/effects";
import { NoticeDeleteCmd } from "@youm-front/notice/domain";
import { timer } from "rxjs";
import { map, mergeMap, switchMap } from "rxjs/operators";
import { NoticeActions } from "../actions";
import { NoticeFacade } from "../facades";

@Injectable()
export class NoticeEffects {
  private static readonly NOTICE_LIFETIME_MS = 30_000;
  private static readonly NOTICE_LIFETIME_INTERVAL_MS = 15_000;

  constructor(private readonly noticeFacade: NoticeFacade) {}

  noticeLifetime$ = createEffect(() =>
    timer(0, NoticeEffects.NOTICE_LIFETIME_INTERVAL_MS).pipe(
      switchMap(() =>
        this.noticeFacade.notices$.pipe(
          map((_) =>
            _.filter(
              (_) =>
                _.value.createdAt + NoticeEffects.NOTICE_LIFETIME_MS <
                Date.now()
            )
          ),
          mergeMap((_) =>
            _.map((_) =>
              NoticeActions.noticeDelete({
                noticeDeleteCmd: new NoticeDeleteCmd({ id: _.value.id })
              })
            )
          )
        )
      )
    )
  );
}
